import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Madam Yas has an extraordinary ability to read energy and push boundaries with precision and care. Every session is transformative.',
  author: 'J.M.',
  role: 'Executive, 3 years'
}, {
  quote: 'I have worked with several Dominants, but none have matched her psychological insight and technical skill. She is truly exceptional.',
  author: 'R.K.',
  role: 'Entrepreneur, 5 years'
}, {
  quote: 'The screening process was thorough, and it made me feel safe from the very beginning. Her professionalism is unmatched.',
  author: 'A.L.',
  role: 'Creative Director, 2 years'
}, {
  quote: 'She creates a space where I can fully surrender without fear. Her presence is commanding yet deeply nurturing.',
  author: 'M.T.',
  role: 'Attorney, 4 years'
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="testimonials" ref={ref} className="py-24 lg:py-32 bg-ink" data-id="element-351">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-352">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-353">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-cinzel" data-id="element-354">
            Testimonials
          </p>
          <h2 className="font-cormorant text-bone text-4xl lg:text-6xl font-light mb-6" data-id="element-355">
            Words from Those Who Know
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-356">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-onyx border border-gold/10 p-8 relative" data-id="element-357">
              <QuoteIcon size={32} className="text-gold/20 mb-4" data-id="element-358" />
              <p className="text-silver-muted italic leading-relaxed mb-6" data-id="element-359">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-gold/20 pt-4" data-id="element-360">
                <p className="text-bone font-cormorant text-lg" data-id="element-361">
                  {testimonial.author}
                </p>
                <p className="text-gold text-xs uppercase tracking-widest" data-id="element-362">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}